import { HttpClient, HttpHeaders, HttpParams ,} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { isNullOrUndefined } from 'util';
import { AppInitialize } from '../app-init.service';
import { ButtonType, ConfirmationModel, ConfirmationPopupComponent } from '../common-component/confirmation-popup/confirmation-popup.component';
import { CommonService } from '../common-services/common-functions.service';
import { AccessLevel, ConfirmationHeader } from '../common-services/enum.service';
import { IShortCutKeys } from '../common-services/interface.service';
import { ApiResponse, CommonFilter } from '../common-services/models.service';

@Injectable()
export class SharedService {

  sharedMaster = {};
  tableConfiguration = {};
  reportConfiguration = {};
  notificationCnt: number = 0;

  sharedStockAuditData: any = null;//-- GID:421 Karan 07112025


  // ddl = { 1: { api: 'state/ddlist', list: new Array<any>() } };
  shortCutKeyListner = new Subject<IShortCutKeys>();
  showLoader = new BehaviorSubject(false);
  autoSearchArray = {};
  masterUrl = {
    1: { 'List': 'account/users?search=', 'Save': 'account/create', 'Delete': 'account/delete/', 'Filter': 'payment/filter', 'isExists': '', 'byId': 'account/user/' }
  };

  searchProgress = false;
  printObject = null;
  formBtn = {
    actionAccess: AccessLevel.None
  };

  storeAssignment = {
    assignedStore: [],
    assignedState: [],
    assignedDistrict: []
  };

  stateDistrict = {
    stateList: [],
    districtList: [],
    storeList: [],//nibha 18072024 GID #38
    totalStore: 0
  };
  vendorstateDistrict = {
    stateList: [],
    districtList: [],
    totalStore: 0
  };
  pageRouteConfig = {
    59: { pageRoute: 'user/scheme/', retriveField: 'sM_Id' },
    60: { pageRoute: 'master/item/', retriveField: 'id' },
    61: { pageRoute: 'master/salt/', retriveField: 'ingredient_Id' },
    62: { pageRoute: 'master/otherbrand/', retriveField: 'obM_Id' },
    63: { pageRoute: 'master/welcomekit/', retriveField: 'wel_Id' },
    64: { pageRoute: 'master/documentlibrary/', retriveField: 'doc_Id' },
    89: { pageRoute: 'store/documentprocess/', retriveField: 'storeId' },
    90: { pageRoute: 'store/execution/', retriveField: 'storeId' },
    91: { pageRoute: 'user/employee/', retriveField: 'empId' },
    95: { pageRoute: 'user/adjustpoints/', retriveField: 'spid' },
    99: { pageRoute: 'user/schemetransaction/', retriveField: 'storeId' },
    103: { pageRoute: 'store/tabsequence/', retriveField: 'tab_Type' },
    106: { pageRoute: 'stockreturn/returnpolicy/', retriveField: 'id' },
    107: { pageRoute: 'batchrecall/recall/', retriveField: 'id' },
    111: { pageRoute: 'master/proportionateschememrp/', retriveField: 'id' },
    123: { pageRoute: 'user/schememasterdetails/', retriveField: 'schemeId' },
    131: { pageRoute: 'master/Notification/', retriveField: 'notification_Id' },
    138: { pageRoute: 'master/TermsAndConditions/', retriveField: 'termsAndConditions_Id' },
    143: { pageRoute: 'store/documentprocess/', retriveField: 'storeId', versionField: 'versionNo' },
    153: { pageRoute: 'store/execution/', retriveField: 'storeId', versionField: 'versionNo' },
    157: { pageRoute: 'master/vendormaster/', retriveField: 'id' },
    158: { pageRoute: 'master/TemplateLocationMaster/', retriveField: 'id' }, //nibha 05-07-2024 gid #22
    160: { pageRoute: 'sales/AddFixDiscount/', retriveField: 'id' }, //nibha 16-07-2024 gid #38
    161: { pageRoute: 'user/productmrprequest/', retriveField: 'id' },//MR_45_46_Product_MRP_NEw_Report

    163: { pageRoute: 'planogram/templatelocation/', retriveField: 'tm_Id' },//MR_5_TemplateLocationMaster
    164: { pageRoute: 'user/productmrpchange/', retriveField: 'id' }, //nibha 01-08-2024 gid #33

    165: { pageRoute: 'planogram/storetemplate/', retriveField: 'stId' }, //MR_5_TemplateLocationMaster
    166: { pageRoute: 'planogram/productlocation/', retriveField: 'templateId' },//MR_48_Product_Location_Master
    167: { pageRoute: 'user/rewardpoint/', retriveField: 'id' },//Nibha  23-10-24 GID #78
    168: { pageRoute: 'user/rewardpointredeem/', retriveField: 'id' },//Nibha  14-11-24 GID #103
    172: { pageRoute: 'user/pettycashmaster/', retriveField: 'id' },//~~~~~~~~~~~~~~~~~ Tushar 2024-12-25 Gid: GujCoMart #131
    171: { pageRoute: 'campaign/rewardpointscheme/', retriveField: 'id' },//Nibha  13-12-2024 GID #120
    173: { pageRoute: 'user/productflagconfig/', retriveField: 'id' },//~~~~~~~~~ Nibha  12-03-25 GID #155
    176: { pageRoute: 'user/incomeexpensecategorycomponent/', retriveField: 'id' },//~~~~~~~~~ Nibha  26-03-2025 GID #159
    181: { pageRoute: 'user/productmappingwithstoreComponent/', retriveField: 'id' },//~~~~~~~~~ Nibha 06-05-2025 GID #163
    184: { pageRoute: 'user/excludeproducttemplatecomponent/', retriveField: 'id' },//~~~~~~~~~ Nibha 13-06-2025 GID #213 ,
    187: { pageRoute: 'store/coupon-code/', retriveField: 'id' }, // Added for managing Coupon Code Master functionality (e.g., create, update)
    189: { pageRoute: 'user/productMappingWithLocalVendorComponent/', retriveField: 'id' },//~~~~~~~~~ GID:323  Karan 28-07-2025// Configuration for route permission and navigation
    191: { pageRoute: 'user/change-sales-rate/', retriveField: 'id' }, //--gid 336 Gaurav 26-08-25 for change-sales-rate
    196: {pageRoute:'master/monthly-incentive-report/' ,retriveField: 'id'}, //-- GID:355 Karan 30092025
    199: {pageRoute:'master/stockaudit/',retriveField: 'action'}, //-- GID:421 Karan 07112025
    200: {pageRoute:'user/stock-adjustment-request/',retriveField: 'id'}, //-- GID:476 Karan 22122025
    201: {pageRoute:'user/stock-transfer-request/',retriveField: 'id'}, //-- GID:476 Karan 22122025
    203: {pageRoute:'user/sales-invoice-bank-payment/',retriveField: 'id'}, //-- GID:488 Karan 26122025
    209: {pageRoute:'user/loyalty-configuration/',retriveField: 'id'}, //-- RID:680 Karan 19022026
    211: {pageRoute:'user/advertisement-configuration/',retriveField: 'id'}, ///RID:672 Karan 05032026
    205: {pageRoute:'user/sales-return-request/',retriveField: 'id'}, ///RID:4932 Karan 16032026
    216: { pageRoute: 'campaign/basketscheme/', retriveField: 'id' },
    23: { pageRoute: 'sales/sapsalesinvoices/', retriveField: 'id' }, //RID:15906 29042026 Karan
    218: { pageRoute: 'user/location-wise-sp-change-request/', retriveField: 'id' }, //RID:15906 29042026 Karan
    222: { pageRoute: 'user/bulk-selling/', retriveField: 'id' }, //-- RID:22658 Karan 12062026
    226: { pageRoute: 'master/festival-master/', retriveField: 'id' }, //-- RID:25396 Karan 26062026
    231: { pageRoute: 'master/yearly-festival/', retriveField: 'id' }, //-- RID:25396 Karan 26062026
    236: { pageRoute: 'user/store-eod-approval/', retriveField: 'id' }, //-- RID:38859 Dhruv 13082026
    238: { pageRoute: 'master/store-direct-pi/', retriveField: 'id' }, //-- RID:38848 Karan 18082026
    246: { pageRoute: 'sales/storemonthlytarget/', retriveField: 'id' }, //Karan RID:22352
    247: {pageRoute:'user/change-product-location-request/',retriveField: 'id'},
    251: {pageRoute:'master/wh-store-product-mapping/',retriveField: 'storeCode'},
  };

  constructor(public dialog: MatDialog, private httpClient: HttpClient, private appInit: AppInitialize) { }
  public isEnableOrVisible(no): boolean {
    return (this.formBtn.actionAccess & no) > 0;
  }

  getConfirmatonConfig(header: ConfirmationHeader, message, _buttonType: ButtonType = ButtonType.YesNo, data: any = null) {
    return this.dialog.open(ConfirmationPopupComponent, {
      width: '400px',
      data: new ConfirmationModel(header, message, _buttonType, data),
      disableClose: true,
      closeOnNavigation: true
    });
  }

  public get StateDistrict(): Observable<any> {
    if (this.stateDistrict.stateList.length === 0) {
      return this.StateDistrictByUser(0);
    } else {
      return Observable.of(CommonService.copyObject(this.stateDistrict));
    }
  }

  public StateDistrictByUser(userid = 0): Observable<any> {
    return this.customGetApi('store/defaultstoredata?userid=' + userid).map((t: any) => {
      this.stateDistrict.stateList = t.states;
      this.stateDistrict.districtList = t.district;
      this.stateDistrict.totalStore = t.totalStore;
      this.stateDistrict.storeList = t.store;  //nibha 18072024 GID #38
      return CommonService.copyObject(this.stateDistrict);
    });
  }

  getTableConfiguration(page: any) {
    if (this.tableConfiguration[page] && this.tableConfiguration[page].length > 0) {
      return Observable.of({ data: this.tableConfiguration[page] });
    } else {
      return this.customGetApi('common/tblconfig?type=' + page).map((t) => {
        this.tableConfiguration[page] = t.data;

        return t;
      }).catch(err => Observable.throw(err));
    }
  }

  getReportConfiguration(page: any) {
    if (this.reportConfiguration[page]) {
      return Observable.of({ data: this.reportConfiguration[page] });
    } else {
      return this.customGetApi('common/reportconfig?type=' + page).map((t) => {

        const filter = this.getSearchFilter(page);
        if (t && t.data && t.data.hasFromToDateField) {
          const d = new Date();
          d.setDate(d.getDate() - (t.data.defDateDurationInDays > 0 ? t.data.defDateDurationInDays : 30));

          filter.filterArray.push({ key: t.data.hasFromToDateField + '_from', value: d });
          filter.filterArray.push({ key: t.data.hasFromToDateField + '_to', value: new Date() });

        }
        if (!isNullOrUndefined(t.data.lstFilterData)) {
          t.data.lstFilterData.forEach(element => {
            filter.filterArray.push({ key: element.defaultSearchField, value: element.defaultSearchValue })
          })

        }
        this.sharedMaster[page].searchFilter = filter;
        this.reportConfiguration[page] = t.data;
        return t;
      }).catch(err => Observable.throw(err));
    }
  }

  getSearchFilter(page: any, _pageSize = 0) {
    if (isNullOrUndefined(this.sharedMaster[page])) {
      this.sharedMaster[page] = new FilterObject(new CommonFilter(page, (_pageSize > 0 ? _pageSize : this.appInit.gridItemsPerPage)));
    }
    return this.sharedMaster[page].searchFilter;
    //let filter = new CommonFilter();
    //if (!isNullOrUndefined(this.sharedMaster[page])) {
    //    filter = this.sharedMaster[page].searchFilter;
    //} else {
    //    filter.pageNumber = 1;
    //    filter.pageSize = pageSize;
    //}
    //return filter;
  }

  // searchDropdownList(ddlFor, param: string = '') {
  //   return this.httpClient.get(this.ddl[ddlFor].api + param).map((t: ApiResponse) => t.data);
  // }

  filter(master: any, param1: any = null, queryParam: any = null): Observable<any> {
    if (!isNullOrUndefined(queryParam)) {
      return this.httpClient.post<ApiResponse>(this.masterUrl[master].Filter + queryParam, param1).map(t => t);
    } else {
      return this.httpClient.post<ApiResponse>(this.masterUrl[master].Filter, param1).map(t => t);
    }
  }

  getFilter(filter): Observable<any> {
    return this.httpClient.post<any[]>('common/filter', filter).map(t => t);
  }

  getList(master: any, param1: any = ''): Observable<any> {
    return this.httpClient.get<any[]>(this.masterUrl[master].List + param1).map(t => t);
  }

  // customGetApi(api: string): Observable<ApiResponse> {
  //
  //   this.showLoader.next(true);
  //   return this.httpClient.get<ApiResponse>(api).map((t) => {{
  //     this.showLoader.next(false);
  //   }
  //     return t;
  //   }).catch((err: any) => {
  //
  //     this.showLosssader.next(false);
  //     return Observable.throw(err)
  //   });

  // }

  customGetApi(api: string): Observable<ApiResponse> {
    return this.httpClient.get<ApiResponse>(api).map(t => t).catch(err => Observable.throw(err));
  }


  customPostApi(api: string, data: any): Observable<ApiResponse> {
    return this.httpClient.post<ApiResponse>(api, data).map(t => t).catch(err => Observable.throw(err));
  }


  // customPostApi(api: string, data: any): Observable<any> {
  //   this.showLoader.next(true);
  //   return this.httpClient.post(api, data,{ responseType: 'blob', observe: 'response' }).map((t) => {{
  //     this.showLoader.next(false);
  //   }

  //     return t;
  //   }).catch((err: any) => {
  //     return Observable.throw(err)
  //   });

  // }

  // customPostApi(api: string, data: any): Observable<ApiResponse> {
  //   this.showLoader.next(true);
  //   return this.httpClient.post<ApiResponse>(api, data).map((t) => {{
  //     this.showLoader.next(false);
  //   }

  //     return t;
  //   }).catch((err: any) => {
  //     return Observable.throw(err)
  //   });

  // }

  previewImage(url: string, filePath: string): Observable<any> {
    if (!isNullOrUndefined(filePath) && filePath !== '') {
      return this.httpClient.get(url + encodeURIComponent(filePath), { responseType: 'blob', observe: 'response' });
    } else {
      return Observable.of(null);
    }
  }

  previewReport(url: string, data: any): Observable<any> {
    return this.httpClient.post(url, data, { responseType: 'blob', observe: 'response' });
  }

  // Attach Document doesn't working in Notification Master GID:65 Karan : 20092024
  uploadFile(_file, dataParam: { id: string, storeCode: string, docType: number }, url = 'common/upload') {
    if (_file) {
      let formData = new FormData();
      formData.append('profileImage', _file, _file.name);
      Object.keys(dataParam).forEach(key => {
        formData.append(key, dataParam[key]);
      });
      //formData.set('content', _file, _file.name);
      let RequestParams = new HttpParams();
      if (dataParam) {
        Object.keys(dataParam).forEach(function (key) {

          RequestParams = RequestParams.append(key, dataParam[key]);
        });
      }
      return this.httpClient.post<any>(url, formData, { params: RequestParams });
    }
  }

  uploadbase64File(_file, dataParam: { StoreId: number, DocumentMasterId: number, docType: number }, url = 'common/uploadbase64') {
    if (_file) {
      let formData = new FormData();
      formData.set('content', _file, _file.name);
      let RequestParams = new HttpParams();
      if (dataParam) {
        Object.keys(dataParam).forEach(function (key) {
          RequestParams = RequestParams.append(key, dataParam[key]);
        });
      }

      return this.httpClient.post<any>(url, formData, { params: RequestParams });
    }
  }

  autoCompleteFilter(val: any, value: any) {

    const searchval = val ? val : '';
    if (value && (!this.autoSearchArray[value] || this.autoSearchArray[value].length == 0)) {
      return this.customGetApi('common/autosearch?keyName=' + value).map(t => {
        if (t.data) {

          const key = Object.keys(t.data[0])[0];
          this.autoSearchArray[value] = t.data.map(x => x[key]);
          return this.autoSearchArray[value].filter(option => option.toLowerCase().includes(searchval.toLowerCase()));
        } else {
          return [];
        }
      });
    } else {
      return Observable.of(((this.autoSearchArray[value]) ? this.autoSearchArray[value].filter(option => option.toLowerCase().includes(searchval.toLowerCase())) : []));
    }
  }

  notificationCount() {
    // this.customGetApi('storenotification/notificationcount').subscribe((t: any) => {
    //   if (t.status) {
    //     this.notificationCnt = t.data;
    //   }
    // });
  }
}

export class FilterObject {
  constructor(private _searchFilter: any = null, private _dataSource: any = null) {
    this.searchFilter = isNullOrUndefined(_searchFilter) ? new CommonFilter() : _searchFilter;
    this.dataSource = _dataSource;
  }
  searchFilter: CommonFilter;
  dataSource = [];

}

// let expenseName = '';
    // if (!isNullOrUndefined(expenseID) && expenseID > 0) {
    //   const list: any = this.getDropdownList(MastersEnum.Expense);
    //   if (!isNullOrUndefined(list) && list.value.length > 0) {
    //     list.value.filter((e) => {
    //       if (e.id == expenseID) {
    //         expenseName = e.name;
    //       }
    //     });
    //   }
    // }
    // return expenseName;
    // getDropdownList(ddlFor) {
  //   const obj = this.ddl[ddlFor];
  //   if (!isNullOrUndefined(obj)) {
  //     if (!isNullOrUndefined(obj.list) && obj.list.length > 0) {
  //       return Observable.of(obj.list);
  //     } else {
  //       return this.httpClient.get(obj.api).map((t: any) => {
  //         if (t.status === true) {
  //           this.ddl[ddlFor].list = t.data;
  //           return t.data;
  //         } else {
  //           return Observable.throw(t.message);
  //         }
  //       });
  //     }
  //   } else {
  //     Logger.Warn(`getDropdownList Not Exists ${ddlFor}`);
  //     return Observable.of(null);
  //   }
  // }

  // getDropdownName(id: number, pageNo: VendorEnum, matchkey = 'id', resultKey = 'name') {
  //   let name = '';
  //   if (!isNullOrUndefined(id) && id > 0) {
  //     const list: any = this.getDropdownList(pageNo);
  //     if (!isNullOrUndefined(list) && list.value.length > 0) {
  //       list.value.filter((e) => {
  //         if (e[matchkey] == id) {
  //           name = e[resultKey];
  //         }
  //       });
  //     }
  //   }
  //   return name;
  // }

  // save(master: any, param1: any = null, queryParam: any = null): Observable<ApiResponse> {
  //   return this.httpClient.post<ApiResponse>(this.masterUrl[master].Save, param1).map(t => t);
  // }

  // isExists(master: any, param1: any = null): Observable<ApiResponse> {
  //   return this.httpClient.get<ApiResponse>(this.masterUrl[master].isExists + param1);
  // }

  // byId(master: any, param1: any = null): Observable<any> {
  //   return this.httpClient.get<ApiResponse>(this.masterUrl[master].byId + param1).map(t => t);;
  // }

  // delete(master: any, param1: any = null, queryParam: any = null): Observable<any> {
  //   return this.httpClient.post<any>(this.masterUrl[master].Delete, param1).map(t => t);
  // }

  // deleteById(master: any, param1: any = null, queryParam: any = null): Observable<any> {
  //   return this.httpClient.get<any>(this.masterUrl[master].Delete + param1).map(t => t);
  // }
